import { Box, Button, Typography } from '@mui/material';
import LaneButtonIcon from './components/LaneButtonIcon';
import { useNavigate } from 'react-router-dom';
import { API_LANE_MANAGEMENT } from '../../../api';

type Props = {
  currentClient: string;
  screen: number;
};

const StaticLaneLayout = ({ currentClient, screen }: Props) => {
  const iconsLayout: { [key: string]: string } = {
    '0': '3',
    '1': '1',
    '2': '1',
    '3': '1',
    '4': '1',
    '5': '1',
    '6': '1',
    '7': '3',
  };

  const handleIconChange = (id: string, index: string) => {
    iconsLayout[id] = index;
  };

  const navigate = useNavigate();
  const handlePublishClick = async () => {
    const args = {
      client: currentClient,
      screen,
      option: '1',
      iconsJSON: iconsLayout,
    };
    const success = await API_LANE_MANAGEMENT.publishStatic(args);
    // if success refresh page else do nothing
    success
      ? setTimeout(() => {
          navigate(0);
          window.scrollTo(0, 0);
        }, 3000)
      : '';
  };

  return (
    <Box
      bgcolor={'#fff'}
      border={'1px solid #d2d8e4'}
      borderRadius={2}
      width={'100%'}
      display={'flex'}
      flexDirection={'column'}
      gap={3}
      alignItems={'center'}
      justifyContent={'center'}
      mt={2}
      mb={2}
      maxWidth={1340}
    >
      <Typography width={'100%'} pl={2} pb={1} fontWeight={'bold'} mb={1} borderBottom={'1px solid #d2d8e4'}>
        Lane Layout
      </Typography>
      <Box
        display={'flex'}
        flexDirection={{ xs: 'column' }}
        width={'100%'}
        // height={'10vh'}
        maxWidth={1000}
        alignItems={'center'}
        justifyContent={'center'}
      >
        {/* <Box display={'flex'} flexDirection={'column'} gap={2} width={'100%'} height={{ xs: '8vh' }}>
          <Typography textAlign={'center'} height={'25%'} fontWeight={'bold'}>
            End Lane
          </Typography>
          <Typography
            bgcolor={'#ff0000'}
            width={'100%'}
            textAlign={'center'}
            height={'75%'}
            display={'grid'}
            sx={{ placeItems: 'center' }}
            fontWeight={'bold'}
          >
            NO ENTRY
          </Typography>
        </Box> */}
        <LaneButtonIcon
          label={'0'}
          id={'0'}
          client={currentClient}
          screen={screen}
          defaultValue={3}
          updateParentValue={handleIconChange}
        />
        <LaneButtonIcon
          label={'1'}
          id={'1'}
          client={currentClient}
          screen={screen}
          defaultValue={1}
          updateParentValue={handleIconChange}
        />
        <LaneButtonIcon
          label={'2'}
          id={'2'}
          client={currentClient}
          screen={screen}
          defaultValue={1}
          updateParentValue={handleIconChange}
        />
        <LaneButtonIcon
          label={'3'}
          id={'3'}
          client={currentClient}
          screen={screen}
          defaultValue={1}
          updateParentValue={handleIconChange}
        />
        <LaneButtonIcon
          label={'4'}
          id={'4'}
          client={currentClient}
          screen={screen}
          defaultValue={1}
          updateParentValue={handleIconChange}
        />
        <LaneButtonIcon
          label={'5'}
          id={'5'}
          client={currentClient}
          screen={screen}
          defaultValue={1}
          updateParentValue={handleIconChange}
        />
        <LaneButtonIcon
          label={'6'}
          id={'6'}
          client={currentClient}
          screen={screen}
          defaultValue={1}
          updateParentValue={handleIconChange}
        />
        {/* <Box display={'flex'} flexDirection={'column'} gap={2} width={'100%'} height={{ xs: '8vh' }}>
          <Typography textAlign={'center'} height={'25%'} fontWeight={'bold'}>
            End Lane
          </Typography>
          <Typography
            bgcolor={'#ff0000'}
            width={'100%'}
            textAlign={'center'}
            height={'75%'}
            display={'grid'}
            sx={{ placeItems: 'center' }}
            fontWeight={'bold'}
          >
            NO ENTRY
          </Typography>
        </Box> */}
        <LaneButtonIcon
          label={'7'}
          id={'7'}
          client={currentClient}
          screen={screen}
          defaultValue={3}
          updateParentValue={handleIconChange}
        />
      </Box>
      <Box display={'flex'} alignItems={'center'} justifyContent={'center'} mb={2}>
        <Button variant='contained' onClick={handlePublishClick}>
          Publish
        </Button>
      </Box>
    </Box>
  );
};

export default StaticLaneLayout;
